export const RESPONSES = {
  YES: 'Oui',
  NO: 'Non',
};
